import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { AdminRewards } from '@arcxgame/contracts/dist/src/typings'
import { ContractTransaction } from '@ethersproject/contracts'
import { BigNumber, Signer } from 'ethers'
import { Network } from 'src/config'
import ArcFarm from './ArcFarm'

export class AdminRewardsFarm extends ArcFarm {
  constructor(
    name: string,
    platform: string,
    pair: string,
    pairLink: string,
    note: string,
    signer: Signer,
    network: Network,
    public contract: AdminRewards,
    client: ApolloClient<NormalizedCacheObject>,
  ) {
    super(name, platform, pair, pairLink, note, signer, network, contract, client)
  }

  /* ========== Getters ========== */

  hasDebtRequirement(): boolean {
    return false
  }

  getStakingToken() {
    return null
  }

  async getAvailableToStake(): Promise<BigNumber> {
    return BigNumber.from(0)
  }

  async getStakingTokenBalance(): Promise<BigNumber> {
    return BigNumber.from(0)
  }

  /* ========== Modifiers ========== */

  stake(): Promise<ContractTransaction> {
    return null
  }
}
